import type {
  Catalog,
  CollectionItem,
  Manifest,
  ReferenceDetail,
  SearchHit
} from "./types";
import { withAppBasePath } from "./routing";

async function fetchJson<T>(path: string, signal?: AbortSignal): Promise<T> {
  const response = await fetch(withAppBasePath(path), { signal });
  if (!response.ok) {
    throw new Error(`Unable to load ${path}: ${response.status}`);
  }
  return (await response.json()) as T;
}

export function loadCatalog(signal?: AbortSignal): Promise<Catalog> {
  return fetchJson<Catalog>("/data/catalog.json", signal);
}

export function loadManifest(path: string, signal?: AbortSignal): Promise<Manifest> {
  return fetchJson<Manifest>(path, signal);
}

export function loadSearchIndex(path: string, signal?: AbortSignal): Promise<SearchHit[]> {
  return fetchJson<SearchHit[]>(path, signal);
}

export function loadCollection(path: string, signal?: AbortSignal): Promise<CollectionItem[]> {
  return fetchJson<CollectionItem[]>(path, signal);
}

export function loadReference(path: string, signal?: AbortSignal): Promise<ReferenceDetail> {
  return fetchJson<ReferenceDetail>(path, signal);
}
